import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import BodyText from 'LuxKit/Typography/BodyText'
import HelpPane from 'components/Common/HelpPane'
import FormatCurrency from 'components/Common/FormatCurrency'
import Modal from 'LuxKit/Modal/Modal'

const Divider = styled.hr`
  grid-column: span 2;
  width: 100%;
  height: 1px;
  margin: 0;
  background-color: ${props => props.theme.palette.neutral.default.six};
  border: none;
`

const PolicyGrid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-row-gap: ${rem(16)};
  grid-column-gap: ${rem(24)};
  margin-top: ${rem(40)};
`

interface Props {
  cancellationInfo?: App.ExperienceItemCancellationInfo;
  date?: string;
  onSupportEmailClick?: () => void
  onSupportNumberClick?: () => void
}

function ExperienceCancellationPolicyModal(props: Props) {
  const { cancellationInfo, onSupportEmailClick, onSupportNumberClick } = props
  return (<Modal title="Cancellation policy">
    {cancellationInfo && (
      <>
        <BodyText className="full-width" variant="large">
          {cancellationInfo.text}
        </BodyText>
        {cancellationInfo.refundPolicies && cancellationInfo.refundPolicies.length > 0 &&
          <PolicyGrid>
            {cancellationInfo.refundPolicies.map((policy, index) =>
              <React.Fragment key={index}>
                {index !== 0 && <Divider />}
                <BodyText variant="medium" weight="bold">
                  {`${policy.periodLabel}`}
                </BodyText>
                { policy.value > 0 && <BodyText variant="medium">
                  {policy.type === 'PERCENTAGE' && `${policy.value}%`}
                  {policy.type === 'ABSOLUTE' && <FormatCurrency value={policy.value} />}
                  {' '}refund
                </BodyText>}
                { policy.value === 0 && <BodyText variant="medium">
                  Non-refundable
                </BodyText>}
              </React.Fragment>,
            )}
          </PolicyGrid>}
      </>
    )}
    <HelpPane onSupportEmailClick={onSupportEmailClick} onSupportNumberClick={onSupportNumberClick} />
  </Modal>)
}

export default ExperienceCancellationPolicyModal
